import {defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {certissueConstants, uriConstants} from "../../constants";

export const certissueActions = {
  readCertIssueList,
  selectCertissueInfo,
  changeSearchInfo,
  settingHistory,
  getCertissueInfo,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 증명서 신청 현황 목록 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: certissueConstants.CERTISSUE_SEARCH_REQUEST,
      payload: info
    }
  }
}


/*********
 증명서 신청 현황 목록 조회
 **********/

function readCertIssueList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CERTISSUE_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(alertActions.error({
            title: null,
            message: errorMessages.systemError
          }))
        }
      )
  }

  function request() {
    return {
      type: certissueConstants.CERTISSUE_REQUEST
    }
  }
  function success(response) {
    return {
      type: certissueConstants.CERTISSUE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certissueConstants.CERTISSUE_FAILURE,
      response
    }
  }
}

/***********
 증명서 신청 현황 상세 선택
 ************/
function selectCertissueInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: certissueConstants.SELECT_REQUEST,
      payload: info
    }
  }
}


/***********
 증명서 신청 현황 히스토리관리
 ************/
function settingHistory(history) {
  return async dispatch => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: certissueConstants.CERTISSUE_HISTORY,
      payload: history
    }
  }
}

/*********
 증명서 신청현황 상세조회
 **********/

function getCertissueInfo(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CERTISSUE_INFO + "/" + crtSeq
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: certissueConstants.DETAIL_REQUEST
    }
  }
  function success(response) {
    return {
      type: certissueConstants.DETAIL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certissueConstants.DETAIL_FAILURE,
      response
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

